import moment from 'moment'
import {useSelector} from 'react-redux'

export const policy_types = [
  {
    id: 'Privacy',
    label: 'Privacy',
  },
  {
    id: 'TermsCondition',
    label: 'Terms & Condition',
  },
  {
    id: 'ApplicationPolicy',
    label: 'Application Policy',
  },
  {
    id: 'RefundPolicy',
    label: 'Refund Policy',
  },
  {
    id: 'EULA (End user license agreement)',
    label: 'EULA (End user license agreement)',
  },
]

export const step_name = [
  {
    id: 'phone',
    label: 'Phone',
  },
  {
    id: 'email',
    label: 'Email',
  },
  {
    id: 'doctor_profile',
    label: 'Doctor Profile',
  },
  {
    id: 'Business Address',
    label: 'Business Address',
  },
  {
    id: 'mci_verification',
    label: 'MCI Verification',
  },
  {
    id: 'doctor_type',
    label: 'Doctor Type',
  },
]

export const business_Type = [
  {
    id: 'Consumer',
    label: 'Consumer',
  },
  {
    id: 'Doctor',
    label: 'Doctor',
  },
  {
    id: 'Pharma',
    label: 'Pharma',
  },
  {
    id: 'ScanCenter',
    label: 'ScanCenter',
  },
]

export const options = [
  {
    label: 'image/*',
    value: 'image/*',
  },
  {
    label: 'application/vnd.ms-excel',
    value: 'application/vnd.ms-excel',
  },
  {
    label: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
  {
    label: 'application/docx',
    value: 'application/docx',
  },
  {
    label: 'application/pdf',
    value: 'application/pdf',
  },
  {
    label: 'text/plain',
    value: 'text/plain',
  },
  {
    label: 'application/msword',
    value: 'application/msword',
  },
  {
    label: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  },
  {
    label: 'application/zip',
    value: 'application/zip',
  },
  {
    label: 'application/x-zip-compressed',
    value: 'application/x-zip-compressed',
  },
  {
    label: 'application/x-compressed',
    value: 'application/x-compressed',
  },
  {
    label: 'multipart/x-zip',
    value: 'multipart/x-zip',
  },
  {
    label: '.xlsx',
    value: '.xlsx',
  },
  {
    label: 'video/x-flv',
    value: 'video/x-flv',
  },
  {
    label: 'video/mp4',
    value: 'video/mp4',
  },
  {
    label: 'application/x-mpegURL',
    value: 'application/x-mpegURL',
  },
  {
    label: 'video/MP2T',
    value: 'video/MP2T',
  },
  {
    label: 'video/3gpp',
    value: 'video/3gpp',
  },
  {
    label: 'video/quicktime',
    value: 'video/quicktime',
  },
  {
    label: 'video/x-msvideo',
    value: 'video/x-msvideo',
  },
  {
    label: 'video/x-ms-wmv',
    value: 'video/x-ms-wmv',
  },
  {
    label: 'application/sla',
    value: 'application/sla',
  },
  {
    label: '.stl',
    value: '.stl',
  },
]

export const currency = [
  {
    label: 'INR',
    value: 'INR',
  },
  {
    label: 'Dollar',
    value: 'Dollar',
  },
  {
    label: 'Euro',
    value: 'Euro',
  },
]

export const setting_tabs = [
  // {
  //   title: 'Profile Setting',
  //   path: '/application_setting/profile_setting',
  // },
  // {
  //   title: 'Clinic Setting',
  //   path: '/application_setting/clinic_setting',
  // },
  // {
  //   title: 'Account Settings',
  //   path: '/application_setting/account_setting',
  // },
  // {
  //   title: 'Theme Settings',
  //   path: '/application_setting/theme_setting',
  // },
  // {
  //   title: 'RX Designer',
  //   path: '/application_setting/rx_designer',
  // },
  {
    title: 'Prescription Designer',
    path: '/doctor/application_setting/prescription_designer',
  },
  // {
  //   title: 'Appointment Setting',
  //   path: '/doctor/application_setting/appointment_setting',
  // },
]
export const setting_tabs_scan = [
  // {
  //   title: 'Profile Setting',
  //   path: '/application_setting/profile_setting',
  // },
  // {
  //   title: 'Clinic Setting',
  //   path: '/application_setting/clinic_setting',
  // },
  // {
  //   title: 'Account Settings',
  //   path: '/application_setting/account_setting',
  // },
  // {
  //   title: 'Theme Settings',
  //   path: '/application_setting/theme_setting',
  // },
  // {
  //   title: 'RX Designer',
  //   path: '/application_setting/rx_designer',
  // },
  {
    title: 'Booking Slot Setting',
    path: '/booking_slot_scan',
  },
]

export const excel_headers = [
  {
    key: 'firstName',
    value: 'First Name',
  },

  {
    key: 'lastName',
    value: 'Last Name',
  },
  {
    key: 'countryCode',
    value: 'Country Code',
  },
  {
    key: 'mobileNumber',
    value: 'Mobile Number',
  },
  {
    key: 'gender',
    value: 'Gender',
  },
  {
    key: 'dob',
    value: 'Date Of Birth',
  },
  {
    key: 'bloodGroup',
    value: 'Blood Group',
  },
  {
    key: 'address',
    value: 'Address',
  },
  {
    key: 'zipCode',
    value: 'ZIP Code',
  },
  {
    key: 'city',
    value: 'City',
  },
  {
    key: 'district',
    value: 'District',
  },
  {
    key: 'state',
    value: 'State',
  },
  {
    key: 'country',
    value: 'Country',
  },
]

export const updateDateFormat = (date: any) => {
  const currentTime = moment() // Get the current time
  // Parse the input date and format it without time
  const parsedDate = moment(date, 'ddd MMM DD YYYY HH:mm:ss ZZ')
  const formattedDate = parsedDate.format('YYYY-MM-DD') // Format the date
  // Combine the formatted date with the current time
  const combinedDateTime = moment(`${formattedDate} ${currentTime.format('HH:mm:ss')}`).utc()
  return combinedDateTime.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
}

export const checkMobileNoValid = (number: any) => {
  if (/^\d*$/.test(number) && number.length <= 10) {
    return true
  } else {
    return false
  }
}

export const checkzipcodeValid = (number: any) => {
  if (/^\d*$/.test(number) && number.length <= 6) {
    return true
  } else {
    return false
  }
}

export const validateMobileNumber = (value: any) => {
  const mobileNumberRegex = /^[0-9]{10}$/
  return mobileNumberRegex.test(value)
}

export const validateCountryCode = (value: any) => {
  const countryCodeRegex = /^(91|1)$/
  return countryCodeRegex.test(value)
}

export const validateGender = (value: any) => {
  const genderRegex = /^(Male|Female|Other)$/
  return genderRegex.test(value)
}

export const validateBloodGroup = (value: any) => {
  // const bloodGroupRegex = /^(A+|A-|B+|B-|AB+|AB-|O+|O-)$/
  // return bloodGroupRegex.test(value)
  const bloodGroupRegex = /^(A|B|AB|O)[+-]$/
  return bloodGroupRegex.test(value)
}

export const validateName = (value: any) => {
  const nonEmptyStringRegex = /^[a-zA-Z0-9-/\s]+$/
  return nonEmptyStringRegex.test(value)
}

export const validateAddress = (value: any) => {
  // const nonEmptyStringRegex = /^[a-zA-Z0-9 !@#$%^&*()_\-+=\{\}\[\];':".,\/<>?\\s]+$/
  // return nonEmptyStringRegex.test(value)
  return true
}

export const validateDate = (value: any) => {
  return moment(value, 'YYYY-MM-DD', true).isValid()
}

export const validateZipCode = (value: any) => {
  const zipCodeRegex = /^[0-9]{5,6}$/
  return zipCodeRegex.test(value)
}

export const camelCase = (str: any) => {
  // // converting all characters to lowercase
  // let ans = str.toLowerCase()

  // // Returning string to camelcase
  // return ans.split(' ').reduce((s: any, c: any) => s + (c.charAt(0).toUpperCase() + c.slice(1)))
  // return str.replace(/[-_]+(.)/g, (_: any, char: any) => char.toUpperCase())
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function convertToCamelCase(inputString: any) {
  // Remove symbols and split the string into words
  let words = inputString
    ?.toLowerCase()
    .replace(/[^a-zA-Z0-9]+/g, ' ')
    .split(' ')

  // Capitalize the first letter of each word
  for (let i = 0; i < words?.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1)
  }

  // Join the words with spaces
  return words?.join(' ')
}

export const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress']

export function logoutTime(time: any, unit: any) {
  let timer = 0
  if (unit === 'm') {
    timer = time * 60 * 1000
  } else if (unit === 'h') {
    timer = time * 60 * 60 * 1000
  } else if (unit === 'd') {
    timer = time * 24 * 60 * 60 * 1000
  }
  return timer
}

export const numberMasking = (mobileNumber: any) => {
  // Convert to string to handle both numbers and strings
  const mobileStr = String(mobileNumber)

  // Ensure it is a valid 10-digit number
  if (!/^\d{10}$/.test(mobileStr)) {
    return 'Invalid mobile number'
  }

  // Manually create the masked format
  return `${mobileStr.slice(0, 2)}**${mobileStr[4]}****${mobileStr[9]}`
}

export const getInitials = (fullName: any) => {
  // Ensure the input is a non-empty string
  if (typeof fullName !== 'string' || !fullName.trim()) {
    return 'Invalid input'
  }

  // Split the name into words, remove extra spaces, and take the first letter of the first and last words
  const words = fullName.trim().split(/\s+/)
  const firstInitial = words[0].charAt(0).toUpperCase()
  const lastInitial = words[words.length - 1].charAt(0).toUpperCase()

  // Return the initials
  return `${firstInitial}${lastInitial}`
}

export const weekdays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export const setTime = (time: any) => {
  const timeParts = time?.split(':') // Split the string to get hours, minutes, and seconds

  // Create a new Date object for today's date
  const currentDate = new Date()

  // Set the hours, minutes, and seconds of the current date based on the API time
  currentDate?.setHours(parseInt(timeParts[0]))
  currentDate?.setMinutes(parseInt(timeParts[1] || '00'))
  currentDate?.setSeconds(parseInt(timeParts[2] || '00'))
  currentDate?.setMilliseconds(0) // Set milliseconds to zero to avoid potential issues
  return currentDate
}

export const getDataStoreValues = (dataStore: any, dataUkey: any) => {
  if (!dataStore || !dataUkey) return undefined

  // Convert keys to lowercase for case-insensitive matching
  const storeKeys: any = Object.keys(dataStore).reduce((acc: any, key: any) => {
    acc[key.toLowerCase()] = key // Map lowercase keys to original keys
    return acc
  }, {})

  const result: any = {}

  // Loop through each key in dataUkey and fetch corresponding value
  Object.keys(dataUkey).forEach((key) => {
    const matchedKey = storeKeys[dataUkey[key].toLowerCase()]
    result[key] = matchedKey ? dataStore[matchedKey] : undefined
  })
  // console.log('result>>>', result)
  return result
}

export const getDataSetValues = (componentData: any, dataUkeyValue: any) => {
  let value: any = ''

  // Ensure componentData and componentData.dataSet exist
  if (!componentData || !componentData.dataSet) {
    return value
  }

  // Step 1: Extract the `dataUkey` value safely
  const normalizedDataSet = Object.keys(componentData.dataSet || {}).reduce(
    (acc: any, key: any) => {
      if (key) acc[key.toLowerCase()] = componentData.dataSet[key]
      return acc
    },
    {}
  )

  // Step 2: Ensure `dataUkeyValue` exists and is valid
  if (dataUkeyValue && normalizedDataSet.hasOwnProperty(dataUkeyValue.toLowerCase())) {
    value = normalizedDataSet[dataUkeyValue.toLowerCase()]
  }
  // console.log('valuevalue>>>', value)
  return value
}

// export const updateDataStoreObj = (obj: any) => {
//   const dataSet = obj.dataSet

//   function updateComponents(components: any) {
//     return components.map((component: any) => {
//       if (component.componentDatasetValue?.dataUkey) {
//         const dataUkeys = component.componentDatasetValue.dataUkey

//         // Clone componentDatasetValue and dataStore before modifying
//         let updatedDatasetValue = {...component.componentDatasetValue}
//         let updatedDataStore = {...updatedDatasetValue.dataStore}

//         Object.entries(dataUkeys).forEach(([key, value]: any) => {
//           const lowerValue = value.toLowerCase()

//           Object.keys(dataSet).forEach((dataKey) => {
//             if (dataKey.toLowerCase() === lowerValue) {
//               updatedDataStore[dataKey] = dataSet[dataKey]
//             }
//           })
//         })

//         updatedDatasetValue.dataStore = updatedDataStore // Assign updated store
//         console.log('updatedDatasetValue>>>', updatedDatasetValue)
//         return {...component, componentDatasetValue: updatedDatasetValue}
//       }
//       return component
//     })
//   }

//   // Deep clone the object before making changes
//   const newObj = {...obj}

//   // Update components at the root level
//   newObj.components = updateComponents(newObj.components)

//   // Update components inside subCategories
//   if (newObj.subCategories) {
//     newObj.subCategories = newObj.subCategories.map((subCat: any) => ({
//       ...subCat,
//       components: updateComponents(subCat.components),
//     }))
//   }

//   return newObj
// }

export const updateDataStoreObj = (obj: any) => {
  const dataSet = obj.dataSet

  function updateComponents(components: any) {
    return components.map((component: any) => {
      if (component.componentDatasetValue?.dataUkey) {
        const dataUkeys = component.componentDatasetValue.dataUkey

        // Clone componentDatasetValue and dataStore before modifying
        let updatedDatasetValue = {...component.componentDatasetValue}
        let updatedDataStore = {...updatedDatasetValue.dataStore}

        Object.entries(dataUkeys).forEach(([key, value]: any) => {
          const lowerValue = value.toLowerCase()

          // Find the matching key in dataSet
          const matchedDataSetKey = Object.keys(dataSet).find(
            (dataKey) => dataKey.toLowerCase() === lowerValue
          )

          if (matchedDataSetKey) {
            // Find the original key in the existing dataStore (case-insensitive match)
            const matchedDataStoreKey = Object.keys(updatedDataStore).find(
              (storeKey) => storeKey.toLowerCase() === matchedDataSetKey.toLowerCase()
            )

            if (matchedDataStoreKey) {
              // Update existing key
              updatedDataStore[matchedDataStoreKey] = dataSet[matchedDataSetKey]
            } else {
              // Add new key using original casing from dataSet
              updatedDataStore[matchedDataSetKey] = dataSet[matchedDataSetKey]
            }
          }
        })

        updatedDatasetValue.dataStore = updatedDataStore // Assign updated store
        return {...component, componentDatasetValue: updatedDatasetValue}
      }
      return component
    })
  }

  // Deep clone the object before making changes
  const newObj = {...obj}

  // Update components at the root level
  newObj.components = updateComponents(newObj.components)

  // Update components inside subCategories
  if (newObj.subCategories) {
    newObj.subCategories = newObj.subCategories.map((subCat: any) => ({
      ...subCat,
      components: updateComponents(subCat.components),
    }))
  }
  return newObj
}

export const application_setting_tabs = [
  {
    title: 'Staff Login Hours',
    path: '/business-app-setting/login-hours',
    businessType: 'Common',
  },
  {
    title: 'Staff Login IP Range',
    path: '/business-app-setting/login-ip-range',
    businessType: 'Common',
  },
  {
    title: 'Staff Login IP Restriction',
    path: '/business-app-setting/ip-restriction',
    businessType: 'Common',
  },
  // {
  //   title: 'Notification Settings',
  //   path: '/business-app-setting/business-notification',
  //   businessType: 'doctor',
  // },
]

export const UserImg = () => {
  return (
    <img
      style={{maxHeight: '16px'}}
      src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA6UlEQVR4nO2UTQ7BUBSFP5FIdMSQdMqABViSWAAGLIWEAQN/Y7ENBlZAIgbaBai85Aykqap6BsKX3KR59/Tc2/Tkwa/gAnPAV62Aqk3zA9AGSirzfFTvbeYyDNMFZjYG+No6TBnwbAwIUvasfMHFxoAl0HnwDxY2BlSVoo62LsvcpKiCJVwlxlMtbJp/N0WgD+wVyfsyZz2gkMY4A7SAEzAAGhEaczaUpql3EuEomluglkBfB3YKQf6ZOAdsgEkScWipKbCWx0PG2iTL62R1MY7iRFdtkxZHHh+9vIK45jkijsGLZTz+kJgb/PBByC6Wpm4AAAAASUVORK5CYII='
      alt='user'
    />
  )
}

export const CertificateImg = () => {
  return (
    <img
      style={{maxHeight: '16px'}}
      src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABlElEQVR4nO2YS0oDQRCGP0EXWfnYuNMD5BJeQQ8gblVEXOhKdOFS0a1CwJxE1KzEhQ/wAHGhF0gQFG0ZqIGmyQziVM+D1A8FSf/VVfOnarqagMFgKIorwFVsvcIqaiDCiakJqQrOhASwiijBWWsFsNZSgrPWCmCt1aTWciVcQ5wJCWDviBKcHb/j2FrOTi3qdfyWAWdCAlhFlOCstQKMZWutAO/AG7DcNCGLwHPGXPgBnoCFiPnVAp0JPwC+gR1gU0QMhDuNmF8l0DzwIvwS0PK4lqw58Ul8ayvkXrhXYHoEPyNc4nMXIb9KoAngS7h2zv62+HzKnlpWpCtcJ2d/R3wuI+RXC7Qu3FHO/hPx2YqQXy3QhnB94BiY8rhJWeuLz16E/GqBZoO5kQg7BA68aqU2FyG/aqAi/1lp5FcXsi8T/gI4l9mx20QhWTAhsSqS1ff+52T4PYilQ3KU73+sMHp/FLIGDL3vQ1nTEHJLCQiTdr2Jr/qLxkb6oB/Atre+6l3jGyHkBnjMuDi2hbuu4LloJH4B9njHuwZTdt8AAAAASUVORK5CYII='
      alt='certificate--v1'
    />
  )
}

export const CapsuleImg = () => {
  return (
    <img
      style={{maxHeight: '16px', padding: '1px'}}
      src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADqElEQVR4nO2ay04UQRSG/53TGmCAQIK4VMDLQl1qvMaV76CAxMsDGC8YH8gouFOSAUFG4nVHooOiBAPEBeMFdeuYk/ydnHS6qrunqmdmMX/SIamuOl3fnNOnT1UBtNVW01QEMAbgMYAKgD+8KmwbY5+WVQHAbQA/ANQSLulzC8AutJgGALxWE50FcBXAMIA9vEYAXAMwp/q94tiW0ACAdU7sE4CzKcacB7DKMeutAFPgryoTegGgN8NY6bvEsS+bHWZ3OJEvAPrqGN9DL4qNm2iSigC+cxLnHOxcoA2x1YUmaJQTkJfXVfO0dSnlD3gFwBRT+m9eFbbJve4sD5/iwyUTueoGbT1MeB/vZkjvkxyTqAoHSVp11SHa+mC4v1cllX8ASvywrgKYAdAB4DBT/nMF9AbAYNLDf7FzpweQTtoSm1ENAdjgffnxTql7JQBPYsaUAfzlmI0kmJDal+LsCcQm2+czljZdABaUZwqNBKkaICSh7Gb7En/xqOLau5RnJhsFIhDHEyDAyS7GjC8b2hdUAuhuBMgx/h22QNSrEu2NNwLEBpElnOLax2zp3TfIsMdwKkfah1TWyxUkj3DSCizp3RuIhnjmMZx0+yLt/0ROIBpCrmVVRbuGk25fs1UOriBRTyzHwPjSOG0/iLtZy3htAzgaAzHLcOqLwPSrZ7mG2RztjrqCRCG2IhChTDAuYXaahWbVtN6pJ7RsEKH6LZ7JqiKAFdqSHR5kATG5W0OUmBJNssGkDaeA717inoAJJM7dg6oUT4JIgkkTTgE9Hpbxsp4xKm1oFVhGh6V4GogkGJsCBbHJSEBaEJO7wfI53POSXZOsyhJmQVaIKIjJ3UW1xj5TB0QSTNkQTqkhoiBJHyJ5L1xl80xQL0TarPWIfSbgR3EwgYLYygqRNmuFOXw//CkKM+cCkTa0dtjHd1muYWouEHqSHZaslRdI4MMTiITNiCVrfcwhtJzfCdOW6XWYNc0+sh/rC6LkE0Iv6KWe0dJhNsE+T9GiENFjBTmBCqXDrIfLS+lzAv4gfOw3xx70rFlWdffZZ6XO01wN8Y0b3rkevS0Zjt5kIm9VGGaB6VVnJ7l4QktK5K+qMNRhFmqfWtqKZ04iWXIK9lmVHblCaBh9PD3PA6AjqmwXmHeqzwyTwQF+Z+QI+yCzYLggqtHj1vWEb5lOlLa5bgah7qkEYLuqzf6ngm5+N6bVv3AI3MVInwl1DrjDXcD33LK53KyD0bbagpv+Aw6f2jHMjcv5AAAAAElFTkSuQmCC'
      alt='capsule'
    />
  )
}

export const CertificateImage = () => {
  return (
    <img
      style={{maxHeight: '16px'}}
      src='data:image/png;base64,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'
      alt='certificate'
    />
  )
}

export const useGetDateTimeFormat = (date: any) => {
  const dataUser: any = useSelector((state) => {
    return state
  })
  const dateFormat = dataUser?.auth?.applicationSetting?.date_format || 'YYYY-MM-DD'
  const formattedDate = moment(date).format(dateFormat)
  if (!date) return 'NA' // return empty if no date
  return formattedDate

  // NOTE-> In some cases, custom hook cant be used inside a function that's not a component
  // or another custom hook — such as inside a callback, event handler, map(), or conditional block.
  // So in some cases we have to use the useSelector hook directly to get the date format.
  // To update this search using "dateFormat" throughtout the app
  // And we can't use custom hook also conditionally, it should be used at the top level of the component.
  // So, we have to use the useSelector hook directly to get the date format.
}

export const appointmenttimeFormat = 'ddd, DD MMM YYYY, hh:mm A'

type Entry = {
  entryType: 'CREDIT' | 'DEBIT'
  amount: string
  id: string
  entryHeading: string
  appointmentId: string
  appointmentDetails: any
  description: string
  currency: string
  paymentId: string
  paymentAmountBreakup: any
  deductionsBreakdown: any
  createdDate: string
}

type Totals = {
  totalCredit: number
  totalDebit: number
  accumulatedBalance: number
}

export function calculateStatementTotals(entries: Entry[]): Totals {
  let totalCredit = 0
  let totalDebit = 0

  entries.forEach((entry) => {
    const amount = parseFloat(entry.amount || '0')

    if (entry.entryType === 'CREDIT') {
      totalCredit += amount
    } else if (entry.entryType === 'DEBIT') {
      totalDebit += amount
    }
  })

  return {
    totalCredit,
    totalDebit,
    accumulatedBalance: totalCredit - totalDebit,
  }
}

export const validatePDFHeight = (num: number, num2: number) => {
  // const num = parseFloat(input)
  if (isNaN(num)) return 'Please enter a valid number.'
  if (num < 0) return 'Value must be at least 0.'
  if (num > 20) return 'Value must not exceed 20.'
  if (Number(num) + num2 > 20) return 'Total height must not exceed 20.'
  const decimal = num.toString().split('.')[1]
  if (decimal && decimal.length > 2) return 'Only two decimal places allowed.'
  return ''
}

export const cmToPx = (num: number) => {
  return Math.round(num * 37.7952755906) // 1 cm = 37.7952755906 px
}

type DosageDataType = {
  dosage: number | string
  durationTime: number | string
  durationValue: string
}

export const calculateDosageQuantity = ({
  dosage = 0,
  durationTime = 0,
  durationValue,
}: DosageDataType): number => {
  if (!durationValue) {
    return 0 // ✅ Fallback return
  }

  const parsedDuration = Number(durationTime) || 0

  let daysMultiplier = 0
  switch (durationValue) {
    case 'Day':
      daysMultiplier = 1
      break
    case 'Week':
      daysMultiplier = 7
      break
    case 'Month':
      daysMultiplier = 30
      break
    case 'Year':
      daysMultiplier = 365
      break
    case 'NaN':
      daysMultiplier = 0
      break
    default:
      return 0 // ✅ return for unknown values
  }

  const totalDays = parsedDuration * daysMultiplier

  let dailyDosage = 0
  if (typeof dosage === 'string' && dosage.includes('-')) {
    dailyDosage = dosage
      .split('-')
      .map((d) => Number(d.trim()) || 0)
      .reduce((acc, val) => acc + val, 0)
  } else {
    dailyDosage = Number(dosage) || 0
  }

  const totalQuantity = dailyDosage * totalDays
  return totalQuantity // ✅ final return
}

export const removeTrailingS = (str: string) => {
  return str.endsWith('s') ? str.slice(0, -1) : str
}

export function calculateAge(dobString: string) {
  const dob = new Date(dobString)
  const today = new Date()

  let years = today.getFullYear() - dob.getFullYear()
  let months = today.getMonth() - dob.getMonth()

  if (months < 0) {
    years--
    months += 12
  } else if (months === 0 && today.getDate() < dob.getDate()) {
    years--
    months = 11
  }
  // if (years > 0) {
  //   return `${years} year(s)`
  // } else if (years <= 0) {
  //   return ` ${months} month(s)`
  // }
  return `${years} year(s) and ${months} month(s)`
}

export const patientDetailsData = [
  {
    id: 0,
    title: 'Medical History',
    icon: '/media/ePulse/icons/rxportal/medicalIcon.png',
    iconColor: ['#17EAD9', '#6078EA'],
    description: 'Lorem ipsum dolor sit amet, consectetur ',
    meditation: [
      {
        id: 0,
        title: 'Combiflam - Twice daily',
      },
      {
        id: 1,
        title: 'Tytan lc - Post dinner daily',
      },
    ],
  },
  {
    id: 1,
    title: 'Prescriptions',
    icon: '/media/ePulse/icons/rxportal/prescriptionIcon.png',
    iconColor: ['#EC87A1', '#A346CD'],
    description: 'Lorem ipsum dolor sit amet, consectetur ',
  },
  {
    id: 2,
    title: 'Lab Results',
    icon: '/media/ePulse/icons/rxportal/labIcon.png',
    iconColor: ['#F350A2', '#FF6877'],
    description: 'Lorem ipsum dolor sit amet, consectetur ',
  },
  {
    id: 3,
    title: 'Appointments',
    icon: '/media/ePulse/icons/rxportal/calenderCheckIcon.png',
    iconColor: ['#6C00FF', '#564EA1'],
    description: 'Lorem ipsum dolor sit amet, consectetur ',
  },
  {
    id: 4,
    title: 'User Profile',
    subHeading: '(User and Family)',
    icon: '/media/ePulse/icons/rxportal/userProfileIcon.png',
    iconColor: ['#17EAD9', '#6078EA'],
    description: 'Lorem ipsum dolor sit amet, consectetur ',
  },
  {
    id: 5,
    title: 'Payments',
    icon: '/media/ePulse/icons/rxportal/paymentIcon.png',
    iconColor: ['#EC87A1', '#A346CD'],
    description: 'Lorem ipsum dolor sit amet, consectetur ',
  },
]

export const calculateDateFromInput = (unit: string, value: any): Date => {
  let years = 0
  let months = 0
  let days = 0
  console.log('unit>>>', unit, 'value>>>', value)
  switch (unit.toLowerCase()) {
    case 'year':
    case 'years':
      years = parseInt(value)
      break
    case 'month':
    case 'months':
      months = parseInt(value)
      break
    case 'day':
    case 'days':
      days = parseInt(value)
      break
    default:
      console.warn('Invalid unit type')
  }

  const currentDate = new Date()
  const resultDate = new Date(
    currentDate.getFullYear() - years,
    currentDate.getMonth() - months,
    currentDate.getDate() - days
  )

  return resultDate
}

export function calculateDOB(years: any, months: any, days: any) {
  // Default invalid inputs to 0
  years = parseInt(years) || 0
  months = parseInt(months) || 0
  days = parseInt(days) || 0

  const today = new Date()

  // Subtract values from today's date
  const dob = new Date(
    today.getFullYear() - years,
    today.getMonth() - months,
    today.getDate() - days
  )

  // Format to yyyy-mm-dd
  // const formattedDOB = dob.toISOString().split('T')[0]
  return dob
}

export function calculateAgeFromDOB(dobString: any) {
  const dob = new Date(dobString)
  const today = new Date()

  let years = today.getFullYear() - dob.getFullYear()
  let months = today.getMonth() - dob.getMonth()
  let days = today.getDate() - dob.getDate()

  // Adjust if current day/month is less than DOB day/month
  if (days < 0) {
    months--
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0)
    days += prevMonth.getDate()
  }

  if (months < 0) {
    years--
    months += 12
  }

  return {years, months, days}
}

export const concataddress = (location: any) => {
  // location must be like this
  // {
  //               street: userData?.userAddress?.street,
  //               city: userData?.userAddress?.city,
  //               district: userData?.userAddress?.district,
  //               zipCode: userData?.userAddress?.zipCode,
  //               state: userData?.userAddress?.state,
  //               country: userData?.userAddress?.country,
  //             }

  const address = Object.values(location)
    .filter((value) => value !== null && value !== undefined && value !== '')
    .join(', ')
  return address || 'NA'
}

export const PAYMENT_MODE = ['ONLINE', 'OFFLINE']

export const PAYMENT_STATUS = [
  {
    id: 1,
    value: 'success',
    label: 'SUCCESS',
  },
  {
    id: 2,
    label: 'FAILED',
    value: 'failed',
  },
  {
    id: 3,
    label: 'VOID',
    value: 'void',
  },
  {
    id: 5,
    label: 'INCOMPLETE',
    value: 'incomplete',
  },
  {
    id: 4,
    label: 'PENDING',
    value: 'pending',
  },
  {
    id: 6,
    label: 'DISPUTE',
    value: 'flagged',
  },
  {
    id: 7,
    label: 'CANCELLED',
    value: 'cancelled',
  },
  {
    id: 8,
    label: 'DROPPED',
    value: 'user_dropped',
  },
]
export const useGetPageLimit = () => {
  const dataUser: any = useSelector((state) => {
    return state
  })
  const pageLimit = dataUser.auth.applicationSetting.default_rows_count_business_admin || 500
  return pageLimit
}

export const updatedDuation = (data: any) => {
  data.map((item: any) => {
    const time = Number(item.durationTime)
    const durationValue =
      time > 1 && !item.durationValue.endsWith('s') ? `${item.durationValue}s` : item.durationValue
    const duration = time > 1 && !item.duration.endsWith('s') ? `${item.duration}s` : item.duration

    return {...item, durationValue, duration}
  })
}
